<template>
  <div>
    <app-collapse type="margin">
      <app-collapse-item title="" :is-visible="true">
        <validation-observer ref="form">
          <b-form @submit.prevent="$emit('submit')">
            <b-row>
              <!-- Data da Receita -->
              <b-col md="6">
                <b-form-group label="Data da Receita" label-for="data-receita">
                  <validation-provider
                    #default="{ errors }"
                    name="Data da Receita"
                    rules="required"
                  >
                    <flat-pickr
                      v-model="receituario.dataReceita"
                      name="fieldDate"
                      :config="{
                        altInput: true,
                        altFormat: 'd/m/Y',
                        enableTime: false,
                        dateFormat: 'Y-m-d',
                      }"
                      :state="errors.length > 0 ? false : null"
                      :disabled="disableForm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Especialidade -->
              <b-col md="6">
                <b-form-group label="Especialidade" label-for="especialidade">
                  <validation-provider
                    #default="{ errors }"
                    name="Especialidade"
                    rules="required"
                  >
                    <v-select
                      v-model="receituario.especialidade"
                      :reduce="(comboEspecialidades) => comboEspecialidades.id"
                      label="descricao"
                      :options="comboEspecialidades"
                      :state="errors.length > 0 ? false : null"
                      data-cy="especialidade"
                      :disabled="true"
                    />
                    <small data-cy="v-especialidade" class="text-danger">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Prescrição -->
              <b-col cols="12">
                <b-form-group label="Prescrição" label-for="prescricao">
                  <validation-provider
                    #default="{ errors }"
                    name="Prescrição"
                    rules="required"
                  >
                    <quill-editor
                      :id="'id_prescricao'"
                      v-model="receituario.prescricao"
                      :options="editorOptions"
                      :disabled="disableForm"
                      :class="{ 'ql-disabled': disableForm }"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Observações -->
              <b-col cols="12">
                <b-form-group label="Observações" label-for="observacao">
                  <b-form-textarea
                    id="observacao"
                    v-model="receituario.observacao"
                    placeholder="Observações adicionais (opcional)"
                    rows="3"
                    :disabled="disableForm"
                  />
                </b-form-group>
              </b-col>

              <!-- Ações -->
              <ButtonsFormVue
                label-edit="Editar Receituário"
                label-save="Salvar Receituário"
                :disable-form="disableForm"
                :loading-button="loading"
                :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
                :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
                @save="salvar"
                @edit="editar"
                @cancel="beforeCancelar"
              />
            </b-row>
          </b-form>
        </validation-observer>
      </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormTextarea,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormCheckbox,
  BModal,
  BFormSelect,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { VBTooltip } from "bootstrap-vue";
import { quillEditor } from "vue-quill-editor";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import mixinsGlobal from "@/mixins";

export default {
  name: "DigitalReceituario",
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
    quillEditor,
    vSelect,
    flatPickr,
    ButtonsFormVue,
  },
  mixins: [mixinsGlobal],
  props: {
    receituarioProps: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      disableForm: true,
      loading: false,
      comboEspecialidades: [],
      receituario: {
        atendimento: null,
        ativo: true,
        dataReceita: null,
        especialidade: null,
        id: null,
        observacao: null,
        paciente: null,
        prescricao: null,
        profissional: null,
        versao: null,
      },
      editorOptions: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image"],
          ],
        },
        placeholder: "Digite o conteúdo aqui...",
        theme: "snow",
      },
    };
  },
  computed: {},
  watch: {
    receituarioProps: {
      handler(newVal) {
        this.setReceituarioData(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    salvar() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch("receituarioModule/save", this.receituario)
              .then((response) => {
                this.receituario = {
                  id: response.data.id,
                  ...response.data.receituario,
                };
                this.disableForm = true;
                this.showMessageSuccess(
                  "Salvar",
                  "Receituario salvo com sucesso!"
                );
                this.cancelar();
              });
          } catch (error) {
            this.MensagemError("Salvar", "Falha ao salvar!");
          } finally {
            this.loading = false;
          }
        }
      });
    },
    editar() {
      this.disableForm = false;
    },
    loadComboEspecialidades(id) {
      this.comboEspecialidades = [];
      this.$store
        .dispatch("combosModule/loadComboEspecialidadesByIdTipoAtendimento", id)
        .then((response) => {
          this.comboEspecialidades = response.data;
        });
    },
    getReceituarioData() {
      return this.receituario;
    },
    setReceituarioData(data) {
      const formatDate = (dateString) => {
        if (!dateString) return "";
        const [day, month, year] = dateString.split("-");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      };

      this.receituario = {
        atendimento: data.atendimento,
        ativo: data.ativo,
        dataReceita: formatDate(data.dataReceita),
        especialidade: data.especialidade,
        id: data.id,
        observacao: data.observacao,
        paciente: data.paciente,
        prescricao: data.prescricao,
        profissional: data.profissional,
        versao: data.versao,
      };
    },
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Deseja realmente sair do cadastro do receituario?", {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.setReceituarioData(this.receituario);
      this.$refs.form.reset();
      this.$emit("back-list");
    },
  },
};
</script>

<style scoped></style>
